import {

	GATEWAY_FETCH,
	GATEWAY_FETCH_SUCCESS,
	GATEWAY_FETCH_FAIL,
} from '../actions';


const INIT_STATE = {
	gatewaylist:[], 
};

export default (state = INIT_STATE, action) => {

	switch (action.type) {
		case GATEWAY_FETCH:
			return { ...state, loading: true, error: ''};
	  case GATEWAY_FETCH_SUCCESS:
			return { ...state, loading: false, gatewaylist: action.payload.gatewaylist, error: ''};
	  case GATEWAY_FETCH_FAIL:
			return { ...state, loading: false, gatewaylist: 0, error: action.payload.message };
			
		default: return { ...state };
	}
}
